import { WrappedLamport } from "./basic";
export class ProfileEntry extends WrappedLamport {
    constructor(reserveId, amount) {
        super(amount);
        this.reserveId = reserveId;
    }
    getReserveId() {
        return this.reserveId;
    }
    isCompatibleWith(that) {
        return this.getReserveId().equals(that.getReserveId());
    }
}
//# sourceMappingURL=ProfileEntry.js.map